import React from 'react';
import { Car } from 'lucide-react';

export function LoadMoreSection({ t, hasMore, isLoadingMore, loadMore, visibleCount, displayedOppsLength }) {
  if (hasMore) {
    return (
      <div className="flex flex-col items-center py-10 gap-3">
        {isLoadingMore ? (
          <>
            <Car className="w-10 h-10 text-emerald-400 animate-pulse" />
            <span className="text-sm text-slate-400">{t('loadingOpportunities')}</span>
          </>
        ) : (
          <>
            <span className="text-xs text-slate-500">{t('showingOf', { visible: visibleCount, total: displayedOppsLength })}</span>
            <button
              onClick={loadMore}
              className="bg-emerald-500 hover:bg-emerald-600 px-6 py-2.5 rounded-lg font-medium transition-colors text-sm flex items-center gap-2"
            >
              <Car className="w-4 h-4" />
              {t('loadMore')}
            </button>
          </>
        )}
      </div>
    );
  }

  if (displayedOppsLength > 0) {
    return (
      <div className="flex flex-col items-center py-8 gap-2">
        <Car className="w-6 h-6 text-slate-600" />
        <span className="text-xs text-slate-500">{t('allLoaded', { count: displayedOppsLength })}</span>
      </div>
    );
  }

  return null;
}

export default LoadMoreSection;
